module.exports = __webpack_public_path__ + "img/hk.f4509161.svg";